import React from "react";
import appicon3 from "../images/app-icon-3.png"

import appicon4 from "../images/app-icon-4.png"
import appicon5 from "../images/app-icon-5.png"
import mobileImage from "../images/app-mobile-image.png"
import appicon7 from "../images/app-icon-7.png"
import appicon8 from "../images/app-icon-8.png"
import appicon9 from "../images/app-icon-9.png"

class Feature extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        /**
         * Your ajax will goes here to get data then call setState
         */
    }

    scrollToTop = () => {
        if (window.screen.width > 700) {
            window.scrollTo({
                top: 50,
                behavior: 'smooth'
            })
        }
        else {
            window.scrollTo({
                top: 350,
                behavior: 'smooth'
            })
        }
    }

    render() {
        return (
            <React.Fragment>
                <div id="features" className="feature-section ptb-100 ">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-9 col-lg-9">
                                <div className="section-heading text-center mb-5">
                                    <h2>Grow your teaching business by 5x</h2>
                                    <p>Create your online presence backed by features that make it easier for you to manage students, increase transaction, and grow your business</p>
                                </div>
                            </div>
                        </div>

                        <div className="row align-items-center justify-content-md-center">
                            <div className="col-lg-4 col-md-12">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="d-flex align-items-start mb-sm-0 mb-md-5 mb-lg-5">
                                            <img src={appicon3} alt="app icon" width="50" className="img-fluid mr-3" />
                                            <div className="icon-text">
                                                <h5 className="mb-2">Store</h5>
                                                <p>Sell your courses and study material to 70 lakh + students across India</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="d-flex align-items-start mb-sm-0 mb-md-5 mb-lg-5">
                                            <img src={appicon4} alt="app icon" width="50" className="img-fluid mr-3" />
                                            <div className="icon-text">
                                                <h5 className="mb-2">Video Lectures</h5>
                                                <p>Grow your brand through your video lectures with free infinite storage</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="d-flex align-items-start mb-sm-0 mb-md-5 mb-lg-5">
                                            <img src={appicon5} alt="app icon" width="50" className="img-fluid mr-3" />
                                            <div className="icon-text">
                                                <h5 className="mb-2">Live Classes</h5>
                                                <p>Take multiple live classes with automatic recordings and unlimited students</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-5 d-none d-sm-none d-md-block d-lg-block">
                                <div className="position-relative pb-md-5 py-lg-0" style={{ display: "flex", justifyContent: "center" }}>
                                    <img alt="placeholder" src={mobileImage} className="img-center img-fluid" />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-12">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="d-flex align-items-start mb-sm-0 mb-md-5 mb-lg-5">
                                            <img src={appicon7} alt="app icon" width="50" className="img-fluid mr-3" />
                                            <div className="icon-text">
                                                <h5 className="mb-2">Online Assessments</h5>
                                                <p>Take unlimited online assessments with your students and share feedback</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="d-flex align-items-start mb-sm-0 mb-md-5 mb-lg-5">
                                            <img src={appicon8} alt="app icon" width="50" className="img-fluid mr-3" />
                                            <div className="icon-text">
                                                <h5 className="mb-2">Stat Dashboard</h5>
                                                <p>Take the guesswork out of marketing with AI-powered student engagement analytics</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="d-flex align-items-start mb-sm-0 mb-md-5 mb-lg-5">
                                            <img src={appicon9} alt="app icon" width="50" className="img-fluid mr-3" />
                                            <div className="icon-text">
                                                <h5 className="mb-2">Privacy Control</h5>
                                                <p>Your data is secured using SSL AES 256-bit encryption providing maximum security</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center action-btns mt-3">
                            <a className="btn btn-brand-02 mr-3" onClick={this.scrollToTop}>Get Started Now</a>
                            {/*<button className="btn btn-brand-02 mr-3" onClick={this.scrollToTop}>Get Started Now</button>*/}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Feature;
